<template>
<!--  <a-icon-->
<!--    type="setting"-->
<!--    theme="twoTone"-->
<!--    twoToneColor="#4a9ff5"-->
<!--    title="修改"-->
<!--    @click="$emit('click')"-->
<!--  ></a-icon>-->

  <a-button
          style="margin-right: 4px"
    size="small"
    icon="message"
    type="primary"
    @click="$emit('click')"
    ghost ></a-button>

</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>
